// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ls-1";
export var messageSideRight = "_ls-2";
export var subscribeToBackInStockBubbleContainer = "_ls-0";